

















import { ProductComparisonSelectorView } from "@zoovu/runner-web-design-base";

export default class ProductComparisonSelectorViewExtended extends ProductComparisonSelectorView {}
